export default "__VITE_ASSET__fkweit1z__"